// Right-side rolling kill feed. Each entry fades out after ~4s.

import type { Team } from '../plane/Plane';

export interface KillFeedItem {
  killer?: string;
  killerTeam?: Team;
  victim: string;
  victimTeam: Team;
}

const teamColor = (t?: Team) => t === 'blue' ? '#7dccff' : t === 'red' ? '#ff8e80' : '#bbb';

export class KillFeed {
  root: HTMLDivElement;

  constructor(root: HTMLDivElement) {
    this.root = root;
  }

  push(item: KillFeedItem): void {
    const el = document.createElement('div');
    Object.assign(el.style, {
      background: 'rgba(8,12,28,0.6)', border: '1px solid rgba(180,200,255,0.18)',
      padding: '4px 10px', borderRadius: '4px', color: '#dde',
      font: '12px sans-serif', letterSpacing: '0.5px',
      transform: 'translateX(20px)', opacity: '0', transition: 'transform .25s, opacity .35s',
    } as CSSStyleDeclaration);
    if (item.killer) {
      el.innerHTML = `<span style="color:${teamColor(item.killerTeam)}">${escapeHtml(item.killer)}</span> ▸ <span style="color:${teamColor(item.victimTeam)}">${escapeHtml(item.victim)}</span>`;
    } else {
      el.innerHTML = `<span style="color:${teamColor(item.victimTeam)}">${escapeHtml(item.victim)}</span> 坠机`;
    }
    this.root.appendChild(el);
    requestAnimationFrame(() => {
      el.style.transform = 'translateX(0)';
      el.style.opacity = '1';
    });
    setTimeout(() => {
      el.style.opacity = '0';
      el.style.transform = 'translateX(20px)';
      setTimeout(() => el.remove(), 400);
    }, 3800);
  }
}

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
